/* eslint-disable */
import downloadApp from "../global/downloadApp.js";

export default {
    data: function() {
        return {
        }
    },
    computed: {},
    methods: {
        randomNum (minNum, maxNum) {
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
        },
        goToH5 (language) {
            const config = [
                'https://K689l.com',
                'https://K689m.com',
                'https://K689n.com',
                'https://K689o.com',
                'https://K689p.com',
                'https://K689h.com',
                'https://K689k.com',
                'https://K689j.com',
                'https://K689.com',
                'https://K689a.com',
                'https://K689b.com',
                'https://K689c.com',
                'https://K689d.com'
            ]
            const index = this.randomNum(0, config.length - 1)
            downloadApp(config[index] + '?language=' + language)
        }
    }
}
